import React from "react";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Projects from "../components/projects/Projects";
function ProjectsPage() {
  return (
    <div>
      <Header />
      <Projects />
      <Footer />
    </div>
  );
}

export default ProjectsPage;
